import * as ActionTypes from '../actions'
import { combineReducers } from 'redux'
import { loadToken, loadLanguage, loadKey } from '../services/sessionService'



const isRecovering = (state = false, action) => {
	switch (action.type) {
		case ActionTypes.LOGIN_REQUEST:
		case ActionTypes.RECOVER_SESSION_REQUEST:
			return true
		case ActionTypes.LOGIN_SUCCESS:
		case ActionTypes.LOGIN_FAILURE:
		case ActionTypes.RECOVER_SESSION_SUCCESS:
		case ActionTypes.RECOVER_SESSION_FAILURE:
			return false
		default:
			return state
	}
}

const user = (state = null, action) => {
	switch (action.type) {
		case ActionTypes.SET_USER:
			return action.user
		case ActionTypes.LOGIN_SUCCESS:
			return action.response.user
		case ActionTypes.RECOVER_SESSION_SUCCESS:
			return action.response
		case ActionTypes.LOGIN_REQUEST:
		case ActionTypes.LOGIN_FAILURE:
		case ActionTypes.LOGOUT:
		case ActionTypes.RECOVER_SESSION_REQUEST:
		case ActionTypes.RECOVER_SESSION_FAILURE:
			return null
		default:
			return state
	}
}

const token = (state = loadToken(), action) => {
	switch (action.type) {
		case ActionTypes.LOGIN_SUCCESS:
			return action.response.token
		case ActionTypes.LOGIN_FAILURE:
		case ActionTypes.LOGOUT:
		case ActionTypes.RECOVER_SESSION_FAILURE:
			return null
		default:
			return state
	}
}

const language = (state = loadLanguage(), action) => {
	switch (action.type) {
		case ActionTypes.LOGIN_SUCCESS:
			return action.response.user.language
		case ActionTypes.SET_LANGUAGE:
			return action.language
		case ActionTypes.LOGIN_FAILURE:
		case ActionTypes.LOGOUT:
		case ActionTypes.RECOVER_SESSION_FAILURE:
			return loadLanguage()
		default:
			return state
	}
}

const key = (state = loadKey(), action) => {
	switch (action.type) {
		case ActionTypes.LOGIN_SUCCESS:
			return action.response.key
		case ActionTypes.LOGIN_FAILURE:
		case ActionTypes.LOGOUT:
		case ActionTypes.RECOVER_SESSION_FAILURE:
			return null
		default:
			return state
	}
}

const error = (state = null, action) => {
	switch (action.type) {
		case ActionTypes.RECOVER_SESSION_FAILURE:
		case ActionTypes.LOGIN_FAILURE:
			return action.error
		case ActionTypes.RECOVER_SESSION_REQUEST:
		case ActionTypes.RECOVER_SESSION_SUCCESS:
		case ActionTypes.LOGIN_REQUEST:
		case ActionTypes.LOGIN_SUCCESS:
			return null
		default:
			return state
	}
}
const sessionReducer = combineReducers({
	isRecovering,
	user,
	token,
	language,
	key,
	error
})

export default sessionReducer


// WEBPACK FOOTER //
// ./src/reducers/session.js